<div class="mt-3">
  @if ((themaGroups$ | async); as themaGroups) {
    <p-accordion [multiple]="true">
      @for (group of themaGroups; track group.parent.code) {
        <p-accordion-panel [value]="group.parent.code">
          <p-accordion-header>[{{ group.parent.code }}] {{ group.parent.heading }}</p-accordion-header>
          <p-accordion-content>
            <div class="flex flex-column gap-3">
              @for (thema of group.children; track thema.code) {
                <div class="flex align-items-center">
                  <p-checkbox name="themas"
                              [value]="thema.code"
                              [(ngModel)]="selectedThemaCodes"
                              [inputId]="'thema-' + thema.code">
                  </p-checkbox>
                  <label [for]="'thema-' + thema.code"
                         class="ml-2">[{{ thema.code }}] {{ thema.heading }}</label>
                </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }
</div>

<div class="flex align-items-center justify-content-center w-full mt-5">
  <p-button (onClick)="save()"
            [disabled]="requestInProcess"
            label="Save"
            i18n-label>
  </p-button>
</div>